import * as Highcharts from 'highcharts';
import { TSemiCricleWidgetModelInputs } from '@monorepo/types';

export const SEMI_CIRCLE_WIDGET_MODEL = {
  createModel: (input?: TSemiCricleWidgetModelInputs): Highcharts.Options => {
    if (!input) return {};

    return {
      chart: {
        spacing: [0, 0, 0, 0],
        plotBackgroundColor: 'transparent',
        backgroundColor: 'transparent',
        plotBorderWidth: 0,
        plotShadow: false,
        shadow: false,
        height: '25%',
      },
      series: [
        {
          type: 'pie',
          innerSize: `${input.innerCircleSizeInPercent || 80}%`,
          data: input.data,
        },
      ],
      title: {
        text: `${input.value}<br/>${input.titleText}`,
        align: 'center',
        verticalAlign: 'middle',
        y: input.titleYAxisOffset || 0,
        style: {
          color: 'white',
          fontSize: `${input.titleFontSize || 16}`,
        },
      },
      credits: {
        enabled: false,
      },
      exporting: {
        enabled: false,
      },
      legend: {
        enabled: false,
      },
      plotOptions: {
        pie: {
          borderWidth: 0,
          size: `${input.sizeInPercent || 100}%`,
          dataLabels: {
            enabled: false,
          },
          startAngle: -90,
          endAngle: 90,
          center: ['50%', '100%'],
        },
      },
    };
  },
};
